module.exports = __webpack_public_path__ + "static/media/server.321e8ff9.jpg";